import { render, staticRenderFns } from "./userCommentForm.vue?vue&type=template&id=0155287a&lang=pug"
import script from "./userCommentForm.vue?vue&type=script&lang=js"
export * from "./userCommentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports